"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NATIVE_DATA_TYPES_DATABASE = void 0;
exports.NATIVE_DATA_TYPES_DATABASE = {
    microsoftSQLServer: {
        INT: {
            normalizedType: "number",
        },
        BIGINT: {
            normalizedType: "number",
        },
        NUMERIC: {
            normalizedType: "number",
        },
        BIT: {
            normalizedType: "number",
        },
        SMALLINT: {
            normalizedType: "number",
        },
        DECIMAL: {
            normalizedType: "number",
        },
        SMALLMONEY: {
            normalizedType: "number",
        },
        TINYINT: {
            normalizedType: "number",
        },
        MONEY: {
            normalizedType: "number",
        },
        FLOAT: {
            normalizedType: "number",
        },
        REAL: {
            normalizedType: "number",
        },
        DATE: {
            normalizedType: "date_time",
        },
        DATETIME2: {
            normalizedType: "date_time",
        },
        SMALLDATETIME: {
            normalizedType: "date_time",
        },
        DATETIME: {
            normalizedType: "date_time",
        },
        TIME: {
            normalizedType: "date_time",
        },
        CHAR: {
            normalizedType: "string",
        },
        VARCHAR: {
            normalizedType: "string",
        },
        TEXT: {
            normalizedType: "string",
            castAs: "VARCHAR(8000)",
        },
        NCHAR: {
            normalizedType: "string",
        },
        NVARCHAR: {
            normalizedType: "string",
        },
        NTEXT: {
            normalizedType: "string",
        },
        BINARY: {
            normalizedType: "string",
        },
        VARBINARY: {
            normalizedType: "string",
        },
    },
    bigquery: {
        INT64: {
            normalizedType: "number",
        },
        FLOAT64: {
            normalizedType: "number",
        },
        NUMERIC: {
            normalizedType: "number",
        },
        BIGNUMERIC: {
            normalizedType: "number",
        },
        STRING: {
            normalizedType: "string",
        },
        DATE: {
            normalizedType: "date_time",
        },
        DATETIME: {
            normalizedType: "date_time",
        },
        TIMESTAMP: {
            normalizedType: "date_time",
        },
        BOOL: {
            normalizedType: "boolean",
        },
        "ARRAY<STRING>": {
            normalizedType: "string[]",
        },
    },
    elasticsearch: {
        date_time: {
            normalizedType: "date_time",
        },
        number: {
            normalizedType: "number",
        },
        string: {
            normalizedType: "string",
        },
        boolean: {
            normalizedType: "boolean",
        },
    },
    mariadb: {
        TINYINT: {
            normalizedType: "number",
            castAs: "INT",
        },
        SMALLINT: {
            normalizedType: "number",
            castAs: "INT",
        },
        MEDIUMINT: {
            normalizedType: "number",
            castAs: "INT",
        },
        INT: {
            normalizedType: "number",
        },
        INTEGER: {
            normalizedType: "number",
            castAs: "INT",
        },
        BIGINT: {
            normalizedType: "number",
            castAs: "INT",
        },
        DECIMAL: {
            normalizedType: "number",
        },
        FLOAT: {
            normalizedType: "number",
        },
        DOUBLE: {
            normalizedType: "number",
        },
        VARCHAR: {
            normalizedType: "string",
            castAs: "CHAR",
        },
        TEXT: {
            normalizedType: "string",
            castAs: "CHAR",
        },
        TINYTEXT: {
            normalizedType: "string",
            castAs: "CHAR",
        },
        CHAR: {
            normalizedType: "string",
        },
        MEDIUMTEXT: {
            normalizedType: "string",
            castAs: "CHAR",
        },
        LONGTEXT: {
            normalizedType: "string",
            castAs: "CHAR",
        },
        DATE: {
            normalizedType: "date_time",
        },
        DATETIME: {
            normalizedType: "date_time",
        },
        TIMESTAMP: {
            normalizedType: "date_time",
            castAs: "DATETIME",
        },
        BOOLEAN: {
            normalizedType: "boolean",
            castAs: null,
        },
        BOOL: {
            normalizedType: "boolean",
            castAs: null,
        },
    },
    postgres: {
        JSONB: {
            normalizedType: "string",
        },
        UUID: {
            normalizedType: "string",
        },
        DECIMAL: {
            normalizedType: "number",
        },
        NUMERIC: {
            normalizedType: "number",
        },
        INT: {
            normalizedType: "number",
        },
        INTEGER: {
            normalizedType: "number",
        },
        BIGINT: {
            normalizedType: "number",
        },
        SMALLINT: {
            normalizedType: "number",
        },
        DOUBLEPRECISION: {
            normalizedType: "number",
            castAs: "DOUBLE PRECISION",
        },
        "DOUBLE PRECISION": {
            normalizedType: "number",
        },
        REAL: {
            normalizedType: "number",
        },
        FLOAT: {
            normalizedType: "number",
        },
        NUMBER: {
            normalizedType: "number",
        },
        BINARY: {
            normalizedType: "string",
        },
        VARBINARY: {
            normalizedType: "string",
        },
        CHAR: {
            normalizedType: "string",
        },
        CHARACTER: {
            normalizedType: "string",
        },
        "CHARACTER VARYING": {
            normalizedType: "string",
        },
        TEXT: {
            normalizedType: "string",
        },
        VARCHAR: {
            normalizedType: "string",
        },
        TIME: {
            normalizedType: "date_time",
        },
        DATE: {
            normalizedType: "date_time",
        },
        TIMESTAMP_LTZ: {
            normalizedType: "date_time",
        },
        TIMESTAMP_NTZ: {
            normalizedType: "date_time",
        },
        TIMESTAMP_TZ: {
            normalizedType: "date_time",
        },
        TIMESTAMP: {
            normalizedType: "date_time",
        },
        BOOLEAN: {
            normalizedType: "boolean",
        },
        "TIMESTAMP WITH TIME ZONE": {
            normalizedType: "date_time",
        },
        "TIMESTAMP WITHOUT TIME ZONE": {
            normalizedType: "date_time",
        },
        ARRAY: {
            normalizedType: "string[]",
        },
    },
    SQLite: {
        BOOLEAN: {
            normalizedType: "boolean",
        },
        NULL: {
            normalizedType: "string",
        },
        INTEGER: {
            normalizedType: "number",
        },
        REAL: {
            normalizedType: "number",
        },
        DECIMAL: {
            normalizedType: "number",
        },
        CHAR: {
            normalizedType: "string",
        },
        TEXT: {
            normalizedType: "string",
        },
        DATE: {
            normalizedType: "date_time",
        },
        TIMESTAMP: {
            normalizedType: "date_time",
        },
    },
    snowflake: {
        FIXED: {
            normalizedType: "number",
        },
        DECIMAL: {
            normalizedType: "number",
        },
        NUMERIC: {
            normalizedType: "number",
        },
        INT: {
            normalizedType: "number",
        },
        INTEGER: {
            normalizedType: "number",
        },
        BIGINT: {
            normalizedType: "number",
        },
        SMALLINT: {
            normalizedType: "number",
        },
        TINYINT: {
            normalizedType: "number",
        },
        BYTEINT: {
            normalizedType: "number",
        },
        FLOAT: {
            normalizedType: "number",
        },
        FLOAT4: {
            normalizedType: "number",
        },
        FLOAT8: {
            normalizedType: "number",
        },
        DOUBLE: {
            normalizedType: "number",
        },
        DOUBLEPRECISION: {
            normalizedType: "number",
            castAs: "DOUBLE PRECISION",
        },
        "DOUBLE PRECISION": {
            normalizedType: "number",
        },
        REAL: {
            normalizedType: "number",
        },
        NUMBER: {
            normalizedType: "number",
        },
        BINARY: {
            normalizedType: "string",
        },
        VARBINARY: {
            normalizedType: "string",
        },
        CHAR: {
            normalizedType: "string",
        },
        CHARACTER: {
            normalizedType: "string",
        },
        "CHARACTER VARYING": {
            normalizedType: "string",
        },
        TEXT: {
            normalizedType: "string",
        },
        VARCHAR: {
            normalizedType: "string",
        },
        STRING: {
            normalizedType: "string",
        },
        TIME: {
            normalizedType: "date_time",
        },
        DATE: {
            normalizedType: "date_time",
        },
        DATETIME: {
            normalizedType: "date_time",
        },
        TIMESTAMP_LTZ: {
            normalizedType: "date_time",
        },
        TIMESTAMP_NTZ: {
            normalizedType: "date_time",
        },
        TIMESTAMP_TZ: {
            normalizedType: "date_time",
        },
        TIMESTAMP: {
            normalizedType: "date_time",
        },
        BOOLEAN: {
            normalizedType: "boolean",
        },
        ARRAY: {
            normalizedType: "string[]",
        },
        VARIANT: {
            normalizedType: "string",
        },
    },
    mysql: {
        TINYINT: {
            normalizedType: "number",
            castAs: "SIGNED",
        },
        SMALLINT: {
            normalizedType: "number",
            castAs: "SIGNED",
        },
        MEDIUMINT: {
            normalizedType: "number",
            castAs: "SIGNED",
        },
        INT: {
            normalizedType: "number",
            castAs: "SIGNED",
        },
        INTEGER: {
            normalizedType: "number",
            castAs: "SIGNED",
        },
        BIGINT: {
            normalizedType: "number",
            castAs: "SIGNED",
        },
        DECIMAL: {
            normalizedType: "number",
            castAs: "DECIMAL(65, 10)",
        },
        FLOAT: {
            normalizedType: "number",
            castAs: "DECIMAL(65, 10)",
        },
        DOUBLE: {
            normalizedType: "number",
            castAs: "DECIMAL(65, 10)",
        },
        CHAR: {
            normalizedType: "string",
            castAs: "CHAR",
        },
        VARCHAR: {
            normalizedType: "string",
            castAs: "CHAR",
        },
        TEXT: {
            normalizedType: "string",
            castAs: "CHAR",
        },
        TINYTEXT: {
            normalizedType: "string",
            castAs: "CHAR",
        },
        MEDIUMTEXT: {
            normalizedType: "string",
            castAs: "CHAR",
        },
        LONGTEXT: {
            normalizedType: "string",
            castAs: "CHAR",
        },
        DATE: {
            normalizedType: "date_time",
        },
        DATETIME: {
            normalizedType: "date_time",
        },
        TIMESTAMP: {
            normalizedType: "date_time",
            castAs: "DATETIME",
        },
        BOOLEAN: {
            normalizedType: "boolean",
        },
        BOOL: {
            normalizedType: "boolean",
        },
    },
    redshift: {
        // By default we treat it as an array. If it's JSON
        // then they can use the SQL snippet field to extract
        // the value they want from it.
        SUPER: {
            normalizedType: "string[]",
        },
        UUID: {
            normalizedType: "string",
        },
        DECIMAL: {
            normalizedType: "number",
        },
        NUMERIC: {
            normalizedType: "number",
        },
        INT: {
            normalizedType: "number",
        },
        INTEGER: {
            normalizedType: "number",
        },
        BIGINT: {
            normalizedType: "number",
        },
        SMALLINT: {
            normalizedType: "number",
        },
        DOUBLEPRECISION: {
            normalizedType: "number",
            castAs: "DOUBLE PRECISION",
        },
        "DOUBLE PRECISION": {
            normalizedType: "number",
        },
        REAL: {
            normalizedType: "number",
        },
        FLOAT: {
            normalizedType: "number",
        },
        NUMBER: {
            normalizedType: "number",
        },
        BINARY: {
            normalizedType: "string",
        },
        VARBINARY: {
            normalizedType: "string",
        },
        CHAR: {
            normalizedType: "string",
        },
        CHARACTER: {
            normalizedType: "string",
        },
        "CHARACTER VARYING": {
            normalizedType: "string",
        },
        TEXT: {
            normalizedType: "string",
        },
        VARCHAR: {
            normalizedType: "string",
        },
        TIME: {
            normalizedType: "date_time",
        },
        DATE: {
            normalizedType: "date_time",
        },
        TIMESTAMP_LTZ: {
            normalizedType: "date_time",
        },
        TIMESTAMP_NTZ: {
            normalizedType: "date_time",
        },
        TIMESTAMP_TZ: {
            normalizedType: "date_time",
        },
        TIMESTAMP: {
            normalizedType: "date_time",
        },
        BOOLEAN: {
            normalizedType: "boolean",
        },
        "TIMESTAMP WITH TIME ZONE": {
            normalizedType: "date_time",
        },
        "TIMESTAMP WITHOUT TIME ZONE": {
            normalizedType: "date_time",
        },
        ARRAY: {
            normalizedType: "string[]",
        },
    },
};
